import { render, staticRenderFns } from "./ServiceStatusLabel.vue?vue&type=template&id=261a8a28&scoped=true"
import script from "./ServiceStatusLabel.vue?vue&type=script&lang=js"
export * from "./ServiceStatusLabel.vue?vue&type=script&lang=js"
import style0 from "./ServiceStatusLabel.vue?vue&type=style&index=0&id=261a8a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261a8a28",
  null
  
)

export default component.exports